module.exports = __webpack_public_path__ + "static/tezis-f0ce64ec334d72c2bba67c637a4752bc.png";